import {addClass, selectDoc} from "../utils/utils";

export const inputEmail = (value) => {
    return (value && /(^\w.*@\w+\.\w)/.test(value))
};

export const inputEmpty = (value) => {
    return (!value || value == '' || value == null)
};

export const inputPassword = (value) => {
    return (value.length >= 5)
};

export const validDate = (value) => {
    return value.match(/^(0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])[\/\-]\d{4}$/)
};

export const serialize = (form) => {

    // Setup our serialized data
    let serialized = {
            properties: {}
        },
        replace = 'properties[';

    // Loop through each field in the form
    for (let i = 0; i < form.elements.length; i++) {

        let field = form.elements[i];

        // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
        if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

        // If a multi-select, get all selections
        if (field.type === 'select-multiple') {
            for (let n = 0; n < field.options.length; n++) {
                if (!field.options[n].selected) continue;

                if (field.name.includes(replace)) {
                    serialized['properties'][field.name.replace(replace, '').replace(']', '')] = field.options[n].value;
                } else {
                    serialized[field.name] = field.options[n].value;
                }
            }
        }

        // Convert field data to a query string
        else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
            if (field.name.includes(replace)) {
                serialized['properties'][field.name.replace(replace, '').replace(']', '')] = field.value;
            } else {
                serialized[field.name] = field.value;
            }
        }
    }

    return serialized;
};

export const clearFilter = (str) => {
    return str
        .replace('_',' ')

        .replace('three', '3')
        .replace('five', '5')
        .replace('seven', '7')
        .replace('seven', '7')
        .replace('fourteen', '14')
        .replace('eighteen', '18')

        .replace('Ring-', '')
        .replace('Necklace-', '')
        .replace('Earring-', '')
        .replace('Bracelet-', '')

        .replace('Gemstone-', '');
}

export const handleize = function (str) {
    //str = str.toLowerCase();

    var toReplace = ['"', "'", "\\", "(", ")", "[", "]", "-"];

    // For the old browsers
    for (var i = 0; i < toReplace.length; ++i) {
        str = str.replace(toReplace[i], "");
    }

    str = str.replace(/\W+/g, "");

    if (str.charAt(str.length - 1) == "-") {
        str = str.replace(/-+\z/, "");
    }

    if (str.charAt(0) == "-") {
        str = str.replace(/\A-+/, "");
    }

    return str
};

export const showErrorPDPForm = (button, error) => {
    let errorsContainer = selectDoc('.errors-container', button.parentNode);
    if(!errorsContainer) {
        errorsContainer = document.createElement('div');
        addClass(errorsContainer, 'errors-container');
        addClass(errorsContainer, 'body6');
        addClass(errorsContainer, 'body6-left');
        button.parentNode.insertBefore(errorsContainer, button);
    }
    errorsContainer.innerHTML = error;
}
